import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VKEY = 'fundle_visitor_id';

const getVisitorId = () => {
  try {
    let v = localStorage.getItem(VKEY);
    if (!v) {
      v = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VKEY, v);
    }
    return v;
  } catch (e) {
    return null;
  }
};

// Fires a lightweight anonymous pageview beacon on every route change so the
// admin dashboard logs every visitor (not only those who open the chat).
const VisitorBeacon = () => {
  const location = useLocation();
  useEffect(() => {
    let sessionId = null;
    try { sessionId = localStorage.getItem('fundle_abhinav_session_id'); } catch (e) { /* ignore */ }
    const payload = {
      path: `${location.pathname}${location.search || ''}`,
      visitor_id: getVisitorId(),
      session_id: sessionId,
      referrer: (typeof document !== 'undefined' && document.referrer) || '',
      title: (typeof document !== 'undefined' && document.title) || '',
    };
    axios.post(`${API}/agent/visit`, payload).catch(() => {});
  }, [location.pathname, location.search]);
  return null;
};

export default VisitorBeacon;
